import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/chat/phone-green.svg'
import _imports_1 from '@/assets/chat/mail-blue.svg'
import _imports_2 from '@/assets/chat/address-icon.svg'
import _imports_3 from '@/assets/chat/addtime-icon.svg'
import _imports_4 from '../../../assets/chat/empty-img-default.svg'


const _withScopeId = n => (_pushScopeId("data-v-549fe6fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mailItem" }
const _hoisted_2 = {
  key: 0,
  class: "infoBox"
}
const _hoisted_3 = { class: "topBox" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { style: {"margin":"20px 0"} }
const _hoisted_10 = {
  key: 0,
  class: "username"
}
const _hoisted_11 = { class: "itemStyle" }
const _hoisted_12 = { class: "numbers" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgBox1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_14 = {
  key: 0,
  class: "title"
}
const _hoisted_15 = {
  key: 1,
  class: "content"
}
const _hoisted_16 = { class: "emails" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgBox3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_18 = {
  key: 0,
  class: "title"
}
const _hoisted_19 = {
  key: 1,
  class: "content"
}
const _hoisted_20 = { class: "address" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgBox2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_22 = {
  key: 0,
  class: "title"
}
const _hoisted_23 = {
  key: 1,
  class: "content"
}
const _hoisted_24 = {
  key: 0,
  class: "addtime"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imgBox4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_26 = {
  key: 0,
  class: "title"
}
const _hoisted_27 = {
  key: 1,
  class: "content"
}
const _hoisted_28 = {
  key: 1,
  class: "empty"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_30 = { class: "empty-text" }

import { computed, ref, watch } from "vue";
import { getFirstXLetters, gaEvent } from "@/utils/format";
import { useStore } from "vuex";
import { dateFormat, dateFormatAm } from "@/utils/format";
import emitter from "@/utils/eventBus";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'contactItem',
  props: {
  currentContact: {
    type: Object,
  },
  skeletonLoading: {
    type: Boolean,
  },
},
  setup(__props) {

const { t } = useI18n();

const props = __props;

const store = useStore();
const isVibe = computed(() => !store.state.isVibe);
const isDemoRef = computed(() => store.state.isDemo);
const currentLang = computed(() => store.state.currentLang);

// 获取当前点击项的详细信息
const mailItemDetail = computed(() => {
  return store.state.clickMailItemDetail;
});

const activeTabName = computed(() => {
  return store.state.activeTabName;
});

const errImg = (data: any) => {
  console.log("图片展示不出来");
  data.showName = true
}

// 控制骨架屏是否出现
// const skeletonLoading = ref(true);
// setTimeout(() => {
//   skeletonLoading.value = false
// }, 1000)


return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.currentContact && Object.keys(__props.currentContact).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              (!__props.skeletonLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (mailItemDetail.value.profile_picture_url)
                      ? (_openBlock(), _createBlock(_component_el_avatar, {
                          key: 0,
                          class: "avatar"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              (!mailItemDetail.value.showName)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: mailItemDetail.value.profile_picture_url,
                                    style: {"width":"68px","height":"68px"},
                                    onError: _cache[0] || (_cache[0] = ($event: any) => (errImg(mailItemDetail.value)))
                                  }, null, 40, _hoisted_6))
                                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(getFirstXLetters)(mailItemDetail.value.name, 3) || '--'), 1))
                            ])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_avatar, {
                          key: 1,
                          class: "avatar"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getFirstXLetters)(mailItemDetail.value.name, 3) || "--"), 1)
                          ]),
                          _: 1
                        }))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_skeleton, {
                style: {"--el-skeleton-circle-size":"68px","width":"100%"},
                loading: __props.skeletonLoading,
                animated: true
              }, {
                template: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_skeleton_item, {
                      variant: "circle",
                      style: {"margin-right":"12px"}
                    })
                  ])
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            (!__props.skeletonLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(mailItemDetail.value.name || "--"), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_el_skeleton, {
              style: {"width":"130px"},
              loading: __props.skeletonLoading,
              animated: true
            }, {
              template: _withCtx(() => [
                _createVNode(_component_el_skeleton_item, { style: {"width":"100%"} })
              ]),
              _: 1
            }, 8, ["loading"]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", {
                  class: _normalizeClass(['number', currentLang.value == 'ar' ? 'rightText' : ''])
                }, [
                  _createElementVNode("div", null, [
                    (!__props.skeletonLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t("chat.numbers")), 1))
                      : _createCommentVNode("", true),
                    (!__props.skeletonLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(__props.currentContact.phone || "--"), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_skeleton, {
                      style: {"width":"130px"},
                      loading: __props.skeletonLoading,
                      animated: true
                    }, {
                      template: _withCtx(() => [
                        _createVNode(_component_el_skeleton_item, { style: {"width":"20%"} }),
                        _createVNode(_component_el_skeleton_item, { style: {"width":"100%"} })
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", {
                  class: _normalizeClass(['email', currentLang.value == 'ar' ? 'rightText' : ''])
                }, [
                  (!__props.skeletonLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t("chat.emails")), 1))
                    : _createCommentVNode("", true),
                  (!__props.skeletonLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(__props.currentContact.email || "--"), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_skeleton, {
                    style: {"width":"200px"},
                    loading: __props.skeletonLoading,
                    animated: true
                  }, {
                    template: _withCtx(() => [
                      _createVNode(_component_el_skeleton_item, { style: {"width":"20%"} }),
                      _createVNode(_component_el_skeleton_item, { style: {"width":"100%"} })
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", {
                  class: _normalizeClass(['email', currentLang.value == 'ar' ? 'rightText' : ''])
                }, [
                  (!__props.skeletonLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t("famikeep200.Address")), 1))
                    : _createCommentVNode("", true),
                  (!__props.skeletonLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(__props.currentContact.address || "--"), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_skeleton, {
                    style: {"width":"200px"},
                    loading: __props.skeletonLoading,
                    animated: true
                  }, {
                    template: _withCtx(() => [
                      _createVNode(_component_el_skeleton_item, { style: {"width":"20%"} }),
                      _createVNode(_component_el_skeleton_item, { style: {"width":"100%"} })
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ], 2)
              ]),
              (!_unref(store).state.deviceType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", {
                      class: _normalizeClass(['email', currentLang.value == 'ar' ? 'rightText' : ''])
                    }, [
                      (!__props.skeletonLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.$t("famikeep200.Added time")), 1))
                        : _createCommentVNode("", true),
                      (!__props.skeletonLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(__props.currentContact.add_time ? (isVibe.value ? _unref(dateFormatAm)(__props.currentContact.add_time, "YYYY-MM-DD HH:mm:ss") :
                  _unref(dateFormat)(__props.currentContact.add_time, "YYYY-MM-DD HH:mm:ss")) : "--"), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_skeleton, {
                        style: {"width":"200px"},
                        loading: __props.skeletonLoading,
                        animated: true
                      }, {
                        template: _withCtx(() => [
                          _createVNode(_component_el_skeleton_item, { style: {"width":"20%"} }),
                          _createVNode(_component_el_skeleton_item, { style: {"width":"100%"} })
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
        ]))
  ]))
}
}

})